<div class="rfq-pricing-table">
  <table
    *ngIf="pricingSchedule; else noRecords"
    class="table table-striped table-hover"
  >
    <thead>
      <tr class="row-header">
        <th>PRICE LEVEL</th>
        <th>DEFAULT DISC. %</th>
        <th class="text-right">QTY: 0</th>
        <ng-container *ngFor="let tier of pricingSchedule?.priceScheduleTiers">
          <th>
            <div class="row row-header__th">
              <div class="mr-2">QTY:</div>
              <div class="row-header__qty">
                <input
                  matInput
                  class="text-right"
                  type="number"
                  [value]="tier?.quantity"
                  readonly
                />
              </div>
            </div>
          </th>
        </ng-container>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Default Discount %</td>
        <td></td>
        <td></td>
        <ng-container *ngFor="let tier of pricingSchedule?.priceScheduleTiers">
          <td class="text-right">
            <ng-container
              *ngIf="pricingSchedule?.modificationType === 'FIXED'; else percentTpl"
            >
              ${{ tier?.amount }}
            </ng-container>
            <ng-template #percentTpl>-{{ tier?.amount }}%</ng-template>
          </td>
        </ng-container>
        <td></td>
      </tr>

      <tr>
        <td>List Price</td>
        <td></td>
        <td>
          <input matInput type="number" [value]="rfq?.wholesale_price" readonly />
        </td>
        <ng-container *ngFor="let tier of pricingSchedule?.priceScheduleTiers">
          <td>
            <input
              matInput
              type="number"
              [value]="
                rfq?.wholesale_price
                  | pricingCalculation
                    : tier?.amount
                    : pricingSchedule?.modificationType
              "
              readonly
            />
          </td>
        </ng-container>
        <td></td>
      </tr>

      <ng-container
        *ngFor="
          let pricingLevel of pricingLevels | pricingOrderAmount: 'percentIncrease';
          let i = index
        "
      >
        <tr>
          <td>{{ pricingLevel?.name }}</td>
          <td class="text-right">-{{ pricingLevel?.percentIncrease }}%</td>
          <td>
            <input
              matInput
              type="number"
              [value]="
                rfq?.wholesale_price
                  | pricingMatrix
                    : 0
                    : pricingSchedule?.modificationType
                    : pricingLevel?.percentIncrease
              "
              readonly
            />
          </td>

          <ng-container *ngFor="let tier of pricingSchedule?.priceScheduleTiers">
            <td>
              <input
                [ngClass]="{
                  overrides:
                    tier | pricingHasOverride: pricingLevel : pricingOverrides,
                }"
                matInput
                type="number"
                [matTooltip]="
                  (tier | pricingHasOverride: pricingLevel : pricingOverrides)
                    ? 'ORIG. PRICE: $' +
                      (rfq?.wholesale_price
                        | pricingMatrix
                          : 0
                          : pricingSchedule?.modificationType
                          : pricingLevel?.percentIncrease)
                    : null
                "
                [value]="
                  rfq?.wholesale_price
                    | pricingMatrix
                      : tier?.amount
                      : pricingSchedule?.modificationType
                      : pricingLevel?.percentIncrease
                "
                [readonly]="!rowOverrides[i]"
                (change)="onChangeAmount($event, tier, pricingLevel)"
              />
            </td>
          </ng-container>
          <td>
            <button
              *ngIf="!rowOverrides[i]; else overrideActions"
              (click)="setOverrideRow(i, true)"
              class="btn"
              type="button"
              matTooltip="Override Price"
            >
              <i class="fas fa-edit pb-3"></i>
            </button>

            <ng-template #overrideActions>
              <div class="d-flex">
                <!-- <button
                  (click)="cancel()"
                  class="btn -pr-2 text-bold"
                  type="button"
                  matTooltip="Cancel"
                >
                  <icon class="pb-2" name="xmark-regular" [size]="14"></icon>
                </button> -->
                <button
                  (click)="saveOverride()"
                  class="btn text-primary"
                  type="button"
                  matTooltip="Done"
                >
                  <i class="fas fa-check pb-3"></i>
                </button>
              </div>
            </ng-template>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <ng-template #noRecords>
    <div class="text-center p-4">
      <h3>No pricing schedule selected.</h3>
    </div>
  </ng-template>
</div>
